import React from 'react';
import {
  EmojiPeople as EmojiPeopleIcon,
  Dashboard as DashboardIcon,
  AssignmentInd as CoachOnboardingIcon,
  RestaurantMenu as RestaurantMenuIcon,
  List as RecipeListIcon,
  Timeline as AnalyticsIcon,
  TrackChanges as TrackChangesIcon,
  Receipt as ReceiptIcon,
  HistoryEdu as FormBuilderIcon,
  AccountCircle as ContractManagerIcon,
  Feed as ReusableContractsIcon,
  RequestQuote as CommissionsIcon,
  Build as ConfigIcon,
  PersonRounded as UserIcon,
  Psychology as PsychologyIcon,
  Campaign as CampaignIcon,
  People as PeopleIcon,
  GroupsRounded as CommunityIcon,
  FactCheck as CoachTaskAdminIcon,
  PermContactCalendar as AvailabilityIcon,
  Fingerprint as FingerprintIcon,
  MoveToInbox as InboxIcon,
  SmsRounded as SmsIcon,
  Gavel as GavelIcon,
  AutoAwesome as AutoAwesomeIcon,
  SwapHoriz as DataMigrationIcon,
  LeaderboardRounded as ACLeadDashboardIcon,
  Web as WebflowDeployerIcon,
} from '@mui/icons-material';

import texts from './texts.json';
import {
  ActivityFeedIcon,
  ChatIcon,
  MealPlannerIcon,
  YourClientIcon,
  WorkoutsManagerIcon,
  LeadIcon,
  ConfigurationIcon,
  StyledISDashboardIcon,
} from './styles';

const pages = {
  MEAL_PLANNER: 'MEAL_PLANNER',
  ACTIVITY_FEED: 'ACTIVITY_FEED',
  CHAT: 'CHAT',
  WORKOUTS_MANAGER: 'WORKOUTS_MANAGER',
  COMMUNITY: 'COMMUNITY',
  LEADS: 'LEADS',
  CONFIG: 'CONFIG',
  CRX_DASHBOARD: 'CRX_DASHBOARD',
  CRX_COACH_ONBOARDING: 'CRX_COACH_ONBOARDING',
  NUTRITION_PLANS: 'NUTRITION_PLANS',
  RECIPES: 'RECIPES',
  RECIPE_EDITOR: 'RECIPE_EDITOR',
  INSIDE_SALES_DASHBOARD: 'INSIDE_SALES_DASHBOARD',
  INSIDE_SALES_LEADS: 'INSIDE_SALES_LEADS',
  INSIDE_SALES: 'INSIDE_SALES',
  INSIDE_SALES_COMMISSIONS: 'INSIDE_SALES_COMMISSIONS',
  INSIDE_SALES_CONTRACTS_MANAGER: 'CONTRACTS_MANAGER',
  MANAGE_CLIENTS: 'MANAGE_CLIENTS',
  ANALYTICS: 'ANALYTICS',
  FORMS: 'FORMS',
  REUSABLE_CONTRACTS: 'REUSABLE_CONTRACTS',
  AC_DASHBOARD: 'AC_DASHBOARD',
  DATA_MIGRATION: 'DATA_MIGRATION',
  AC_LEAD_DASHBOARD: 'AC_LEAD_DASHBOARD',
  COACH_TASK_ADMIN: 'COACH_TASK_ADMIN',
  AI_COACH_PROFILE: 'AI_COACH_PROFILE',
  AI_COACH_INSTAGRAM_IDENTITY: 'AI_COACH_INSTAGRAM_IDENTITY',
  COMMISSIONS: 'COMMISSIONS',
  CRX_COACH_CONFIGS: 'CRX_COACH_CONFIGS',
  IS_COACH_CONFIGS: 'IS_COACH_CONFIGS',
  INTERNAL_ASSIGNMENTS: 'INTERNAL_ASSIGNMENTS',
  USER_MANAGEMENT: 'USER_MANAGEMENT',
  INTERNAL_USERS: 'INTERNAL_USERS',
  MY_COMMISSIONS: 'MY_COMMISSIONS',
  COACH_VOICE: 'COACH_VOICE',
  POD_SETTINGS: 'POD_SETTINGS',
  CHECK_IN_THEMES: 'CHECK_IN_THEMES',
  IS_AVAILABILITY: 'IS_AVAILABILITY',
  INSTAGRAM_ANALYTICS: 'INSTAGRAM_ANALYTICS',
  SMART_CONTEXT_ANALYTICS: 'SMART_CONTEXT_ANALYTICS',
  SDR_LEAD_INBOX: 'SDR_LEAD_INBOX',
  MASS_TEXT_OUTREACH: 'MASS_TEXT_OUTREACH',
  WEBFLOW_DEPLOYER: 'WEBFLOW_DEPLOYER',
  DISPUTES: 'DISPUTES',
  RELEASE_NOTES: 'RELEASE_NOTES',
};

const pagesConfig = {
  [pages.MEAL_PLANNER]: {
    title: texts.mealPlanner,
    icon: <MealPlannerIcon />,
    path: 'mealPlanner',
  },
  [pages.ACTIVITY_FEED]: {
    title: texts.activityFeed,
    icon: <ActivityFeedIcon />,
    path: 'feed',
  },
  [pages.CHAT]: {
    title: texts.chat,
    icon: <ChatIcon />,
    path: 'chat',
  },
  [pages.WORKOUTS_MANAGER]: {
    title: texts.workoutsManager,
    icon: <WorkoutsManagerIcon />,
    path: 'workoutsManager',
  },
  [pages.LEADS]: {
    title: texts.leads,
    icon: <LeadIcon />,
    path: 'leads',
  },
  [pages.CONFIG]: {
    title: texts.configuration,
    icon: <ConfigurationIcon />,
    path: 'config',
  },
  [pages.CRX_DASHBOARD]: {
    title: texts.crxDashboard,
    icon: <DashboardIcon />,
    path: 'dashboard',
  },
  [pages.CRX_COACH_ONBOARDING]: {
    title: texts.crxCoachManagement,
    icon: <CoachOnboardingIcon />,
    path: 'coachOnboarding',
  },
  [pages.MY_COMMISSIONS]: {
    title: texts.myCommissions,
    icon: <ReceiptIcon />,
    path: 'myCommissions',
  },
  [pages.RECIPES]: {
    title: texts.recipes,
    icon: <RecipeListIcon />,
    path: 'recipes',
  },
  [pages.RECIPE_EDITOR]: {
    title: texts.recipeEditor,
    icon: <RestaurantMenuIcon />,
    path: 'recipeEditor',
  },
  [pages.INSIDE_SALES_DASHBOARD]: {
    title: texts.insideSalesDashboard,
    icon: <StyledISDashboardIcon />,
    path: 'insideSalesDashboard',
  },
  [pages.INSIDE_SALES_LEADS]: {
    title: texts.INSIDE_SALES_LEADS,
    icon: <EmojiPeopleIcon />,
    path: 'leads',
  },
  [pages.INSIDE_SALES]: {
    title: texts.INSIDE_SALES,
    icon: <TrackChangesIcon />,
    path: 'sales',
  },
  [pages.INSIDE_SALES_COMMISSIONS]: {
    title: texts.INSIDE_SALES_COMMISSIONS,
    icon: <ReceiptIcon />,
    path: 'isCommissions',
  },
  [pages.MANAGE_CLIENTS]: {
    title: texts.yourClients,
    icon: <YourClientIcon />,
    path: 'manageClients',
  },
  [pages.COMMUNITY]: {
    title: texts.community,
    icon: <CommunityIcon />,
    path: 'community',
  },
  [pages.ANALYTICS]: {
    title: texts.analytics,
    icon: <AnalyticsIcon />,
    path: 'analytics',
  },
  [pages.INSIDE_SALES_CONTRACTS_MANAGER]: {
    title: texts.INSIDE_SALES_CONTRACTS_MANAGER,
    icon: <ContractManagerIcon />,
    path: 'isContractsManager',
  },
  [pages.FORMS]: {
    title: texts.forms,
    icon: <FormBuilderIcon />,
    path: 'forms',
  },
  [pages.REUSABLE_CONTRACTS]: {
    title: texts.reusableContracts,
    icon: <ReusableContractsIcon />,
    path: 'reusableContracts',
  },
  [pages.AC_DASHBOARD]: {
    title: texts.acDashboard,
    icon: <DashboardIcon />,
    path: 'acDashboard',
  },
  [pages.DATA_MIGRATION]: {
    title: texts.dataMigration,
    icon: <DataMigrationIcon />,
    path: 'dataMigration',
  },
  [pages.AC_LEAD_DASHBOARD]: {
    title: texts.acLeadDashboard,
    icon: <ACLeadDashboardIcon />,
    path: 'acLeadDashboard',
  },
  [pages.COACH_TASK_ADMIN]: {
    title: texts.coachTaskAdmin,
    icon: <CoachTaskAdminIcon />,
    path: 'coachTaskAdmin',
  },
  [pages.AI_COACH_PROFILE]: {
    title: texts.aiCoachProfile,
    icon: <PsychologyIcon />,
    path: 'aiCoachProfile',
  },
  [pages.AI_COACH_INSTAGRAM_IDENTITY]: {
    title: texts.aiCoachInstagramIdentity,
    icon: <FingerprintIcon />,
    path: 'aiCoachInstagramIdentity',
  },
  [pages.COMMISSIONS]: {
    title: texts.commissions,
    icon: <CommissionsIcon />,
    path: 'commissions',
  },
  [pages.CRX_COACH_CONFIGS]: {
    title: texts.crxCoachConfigs,
    icon: <ConfigIcon />,
    path: 'crxCoachConfigs',
  },
  [pages.IS_COACH_CONFIGS]: {
    title: texts.iSCoachConfigs,
    icon: <ConfigIcon />,
    path: 'ISCoachConfigs',
  },
  [pages.INTERNAL_USERS]: {
    title: texts.internalUsers,
    icon: <UserIcon />,
    path: 'internalUsers',
  },
  [pages.INTERNAL_ASSIGNMENTS]: {
    title: texts.internalAssignments,
    icon: <UserIcon />,
    path: 'internalAssignments',
  },
  [pages.USER_MANAGEMENT]: {
    title: texts.userManagement,
    icon: <UserIcon />,
    path: 'userManagement',
  },
  [pages.COACH_VOICE]: {
    title: 'Coach Voice',
    icon: <CampaignIcon />,
    path: 'coachVoice',
  },
  [pages.POD_SETTINGS]: {
    title: texts.podSettings,
    icon: <PeopleIcon />,
    path: 'podSettings',
  },
  [pages.CHECK_IN_THEMES]: {
    title: texts.checkInThemes,
    icon: <PsychologyIcon />,
    path: 'checkInThemes',
  },
  [pages.IS_AVAILABILITY]: {
    title: texts.isAvailability,
    icon: <AvailabilityIcon />,
    path: 'isAvailability',
  },
  [pages.INSTAGRAM_ANALYTICS]: {
    title: texts.instagramAnalytics,
    icon: <AnalyticsIcon />,
    path: 'instagramAnalytics',
  },
  [pages.SMART_CONTEXT_ANALYTICS]: {
    title: 'Smart Context Analytics',
    icon: <AnalyticsIcon />,
    path: 'smartContextAnalytics',
  },
  [pages.SDR_LEAD_INBOX]: {
    title: texts.sdrLeadInbox,
    icon: <InboxIcon />,
    path: 'sdrLeadInbox',
  },
  [pages.MASS_TEXT_OUTREACH]: {
    title: texts.massTextOutreach,
    icon: <SmsIcon />,
    path: 'massTextOutreach',
  },
  [pages.WEBFLOW_DEPLOYER]: {
    title: texts.webflowDeployer,
    icon: <WebflowDeployerIcon />,
    path: 'webflowDeployer',
  },
  [pages.DISPUTES]: {
    title: 'Disputes',
    icon: <GavelIcon />,
    path: 'disputes',
  },
  [pages.RELEASE_NOTES]: {
    title: 'Release Notes',
    icon: <AutoAwesomeIcon />,
    path: 'releaseNotes',
  },
};

export default pages;

export {
  pagesConfig,
};
